import http from '@utils/http'
/**
 * 获取可开票订单列表
 */
export function getInvoicePayList(data): Promise<any> {
    return http.post('/pay/hasInvoicePayRecord', data || {})
}

/* 
* 提交开票申请
*/
export function submitApply(data): Promise<any> {
    return http.post('/pay/submitApplications', data || {})
}

/* 
* 查询开票历史记录
*/
export function getInvoiceHistory(data): Promise<any> {
    return http.post('/pay/historyInvoiceRecord', data || {})
}

/* 
* 查看开票详情
*/
export function getInvoiceDetails(data): Promise<any> {
    return http.post('/pay/queryInvoiceDetails', data || {})
}

/* 
* 修改开票申请
*/
export function modifyInvoiceApply(data): Promise<any> {
    return http.post('/pay/modifyInvoice', data || {})
}

/* 
* 撤销开票申请
*/
export function cancelInvoiceApply(data): Promise<any> {
    return http.post('/pay/revocationInvoice', data || {})
}

/* 
* 查询多个订单总开票金额
*/
export function getInvoiceOrderTotalFee(data): Promise<any> {
    return http.post('/pay/queryInvoiceOrderTotalFee', data || {})
}